(() => {
  let translations = {};
  try { translations = JSON.parse(document.querySelector('[data-trendiko-navigation]')?.textContent || '{}').translations || {}; } catch {}
  const polish = () => {
    document.querySelectorAll('.search-results a[href^="/products/trendiko-smartcup-dynamic-therapy-massager"]').forEach(link => link.remove());
    document.querySelectorAll('.search-overlay input[type=search]').forEach(input => {
      const prompt = translations['Search all products'];
      if (prompt && input.getAttribute('placeholder') !== prompt) input.setAttribute('placeholder', prompt);
    });
    document.querySelectorAll('.product-card h3 a, .product-detail-copy h1').forEach(el => {
      const text = el.textContent.trim();
      if (text.startsWith('Trendiko ')) el.textContent = text.slice(9);
    });
    const purchase = document.querySelector('.product-purchase');
    const delivery = document.querySelector('.product-detail-copy .delivery-summary');
    if (purchase && delivery && purchase.nextElementSibling !== delivery) purchase.after(delivery);
  };
  polish();
  const app = document.getElementById('app');
  if (app) new MutationObserver(polish).observe(app, {childList:true, subtree:true});
})();

